import { makeStyles } from '@mui/styles';
const useStyles = makeStyles({
  wrapper: {
    height: '100vh',
    padding: '64px',
    display: 'flex',
    textAlign: 'center',
    alignItems: 'center',
    flexDirection: 'column',
    justifyContent: 'center'
  },
  logo: {
    '& img': {
      height: '64px',
      width: '310px'
    }
  },
  message: {
    maxWidth: '1200px',
    margin: '32px'
  },
  actions: {
    display: 'flex',
    margin: '0 -6px',
    marginTop: '12px',
    minWidth: '344px',
    minHeight: '48px',
    '& .MuiButton-root': {
      width: '160px',
      margin: '0 6px'
    }
  }
});
export default useStyles;